<template>
  <div :class="{ block: isOpen, hidden: !isOpen }" class="border-b border-gray-700 md:hidden">
    <div class="block pt-4 pb-3 border-t border-white md:hidden">
      <div class="flex items-center px-5">
        <div class="flex-shrink-0">
          <img class="w-10 h-10 rounded-full" :src="require('../../assets/logo.png')" />
        </div>

        <div class="ml-3">
          <div class="text-base font-medium leading-none text-white">{{ nombreCompleto }}</div>
          <div class="mt-1 text-sm font-medium leading-none text-gray-300">
            {{ documentoCompleto }} | Nº {{ contrato | nroAfiliado(integrante) }}
          </div>
        </div>
      </div>

      <div class="px-2 mt-3">
        <router-link
          class="block px-3 py-2 font-medium text-gray-200 bg-blue-900 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none"
          to="/"
        >
          Mis credenciales
        </router-link>

        <a
          @click="logout"
          href="#"
          class="block px-3 py-2 mt-1 font-medium text-gray-200 bg-blue-900 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none"
        >
          Cerrar sesión
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import * as auth from '@/auth'
import credentialProps from '@/mixins/credentialProps'

const { emitLogout } = auth

export default {
  props: {
    user: { type: Object, required: true },
    isOpen: { type: Boolean, required: true },
  },

  mixins: [credentialProps],

  methods: {
    logout() {
      emitLogout()
    },
  },

  computed: {
    credencial() {
      return this.user.credencial
    },
  },
}
</script>
